import { api } from '@api'
import type { ChannelReads } from '@hvf/contracts'

export const handleGetChannelReads = async (userId: string) => {
  if (!userId) return []
  const { data } = await api().from('channel_reads').select('*').eq('user_id', userId)

  return data || []
}

export const upsertChannelRead = async (payload: {
  userId: string
  channelRead: Partial<ChannelReads>
}) => {
  const { userId, channelRead } = payload
  if (!userId || !channelRead.channel_id) throw new Error('Missing required fields for channel read')

  const updatePayload: any = {
    user_id: userId,
    channel_id: channelRead.channel_id,
    is_subscribed: channelRead.is_subscribed,
    last_read_at: new Date().toISOString(),
  }

  // Only include last_read_message_id if it exists to prevent null constraint errors
  if (channelRead.last_read_message_id) {
    updatePayload.last_read_message_id = channelRead.last_read_message_id
  }

  const { error } = await api().from('channel_reads').upsert(updatePayload)

  if (error) throw error
}
